module.exports = __webpack_public_path__ + "img/index.a84b7539.png";